import { lazyRouteComponent } from "@tanstack/react-router";
import type { At } from "../../router";

export const ExpensesRoutes = (at: At) => [
  at("/expenses", lazyRouteComponent(() => import("./Expenses"), "MyExpenses")),
  at("/expenses/approvals", lazyRouteComponent(() => import("./Expenses"), "ExpenseApprovals")),
  at("/expenses/report", lazyRouteComponent(() => import("./Expenses"), "ExpenseReport")),
];
